import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

export const getHotSearchParam = (key: string): string | null => {
	const url = new URL(window.location.href);
	const value = url.searchParams.get(key);
	return value;
};

export const useHotSearchParam = (key: string): string | null => {
	const searchParams = useSearchParams();
	const [value, setValue] = useState<string | null>(searchParams.get(key));

	useEffect(() => {
		setValue(searchParams.get(key));
	}, [searchParams, key]);

	return value;
};
